import { Component, OnInit } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import {
  Contact,
  labelStatutContact,
  telephoneParDefaut,
} from '../../../core/models/contact.model';
import { ContactService } from '../../../core/services/contact.service';
import { APP_ROUTES } from '../../../core/constants/app-routes';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { SearchPipe } from '../../../core/pipes/search.pipe';

@Component({
    selector: 'app-liste-contacts',
    templateUrl: './liste-contacts.component.html',
    styleUrls: ['./liste-contacts.component.css'],
    imports: [RouterLink, FaIconComponent, FormsModule, SearchPipe, TranslateModule]
})
export class ListeContactsComponent implements OnInit {
  contacts: Contact[] = [];
  query = '';
  loading = true;
  error = false;
  readonly routes = APP_ROUTES;

  constructor(
    private readonly contactService: ContactService,
    private readonly translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.contactService.findAll().subscribe({
      next: (contacts) => {
        this.contacts = contacts ?? [];
        this.loading = false;
      },
      error: () => {
        this.error = true;
        this.loading = false;
      },
    });
  }

  fullName(contact: Contact): string {
    return (
      `${contact.prenomDto ?? ''} ${contact.nomDto ?? ''}`.trim() ||
      this.translate.instant('contacts.sansNom')
    );
  }

  subtitle(contact: Contact): string {
    const phone = telephoneParDefaut(contact)?.numeroDto?.trim();
    if (phone) {
      return phone;
    }
    if (contact.mailDto?.trim()) {
      return contact.mailDto.trim();
    }
    return this.translate.instant('contacts.aucuneCoordonnee');
  }

  statutLabel(contact: Contact): string {
    return labelStatutContact(contact.statutDto);
  }
}
